"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightTitleConfig = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
function InsightTitleConfig(props) {
    var hideTitle = props.hideTitle, widget = props.widget, setVisualPropsConfigurationTitle = props.setVisualPropsConfigurationTitle, isHidingOfWidgetTitleEnabled = props.isHidingOfWidgetTitleEnabled;
    var intl = react_intl_1.useIntl();
    var _a = tslib_1.__read(react_1.useState(hideTitle), 2), widgetTitleState = _a[0], setWidgetTitleState = _a[1];
    var handleHideTitleChange = function (isChecked) {
        setWidgetTitleState(isChecked);
        setVisualPropsConfigurationTitle(widget, isChecked);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, isHidingOfWidgetTitleEnabled ? (react_1.default.createElement("div", { className: "configuration-category s-hide-title-configuration" },
        react_1.default.createElement(sdk_ui_kit_1.Typography, { tagName: "h3", className: "s-viz-title-headline" },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "configurationPanel.visualprops.sectionTitle" })),
        react_1.default.createElement(sdk_ui_kit_1.Checkbox, { onChange: handleHideTitleChange, value: widgetTitleState, text: intl.formatMessage({ id: "configurationPanel.visualprops.hideTitle" }), labelSize: "small" }))) : null));
}
exports.InsightTitleConfig = InsightTitleConfig;
//# sourceMappingURL=InsightTitleConfig.js.map